import { useTranslation } from 'react-i18next';

import styles from './MainFooterAbout.module.scss';
import { MainFooterSocials } from './MainFooterSocials';

export const MainFooterAbout = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className={styles.footerCardDescription}>{t('footer.platformDescription')}</p>
      <div className={styles.footerFollow}>{t('footer.socialLinksTitle')}</div>
      <MainFooterSocials />
    </>
  );
};
